import { IconLayoutDashboard } from "@tabler/icons-react";
import { createElement, lazy, Suspense } from "react";

import { CAPS } from "@/shell/roles";

import type { FeatureRoute, NavItem } from "../types";

const DashboardPage = lazy(() => import("./DashboardPage").then((m) => ({ default: m.DashboardPage })));
const page = (surface: "admin" | "portal") =>
  createElement(Suspense, { fallback: null }, createElement(DashboardPage, { surface }));

export const routes: FeatureRoute[] = [
  { path: "/admin", roles: CAPS.admin.dashboard, element: page("admin") },
  { path: "/portal", roles: CAPS.portal.dashboard, element: page("portal") },
];

export const nav: NavItem[] = [
  { label: "Dashboard", path: "/admin", icon: IconLayoutDashboard, surface: "admin", roles: CAPS.admin.dashboard },
  { label: "Dashboard", path: "/portal", icon: IconLayoutDashboard, surface: "portal", roles: CAPS.portal.dashboard },
];
